import { Id, Identifiable, Planzone, ProjectPortfolio } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type PersistedPortfolio = Identifiable<Omit<ProjectPortfolio, "projects">> & {
  projects: Id[];
};

function extractProjectPortfolios(
  planzone: Identifiable<Planzone>,
): PersistedPortfolio[] {
  return planzone.data && !!planzone.data.projectPortfolios
    ? JSON.parse(planzone.data.projectPortfolios)
    : [];
}

function portfoliosToString(portfolios: PersistedPortfolio[]) {
  return JSON.stringify(portfolios);
}

function updateProjectPortfolio(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    portfolio: Identifiable<ProjectPortfolio>,
    nextPortfolio: ProjectPortfolio,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then((planzone) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/planzones/${planzone.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            data: {
              projectPortfolios: portfoliosToString(
                extractProjectPortfolios(planzone).map((p) =>
                  p.uuid === portfolio.uuid
                    ? {
                        ...p,
                        ...nextPortfolio,
                        projects: nextPortfolio.projects.map(
                          ({ uuid }) => uuid,
                        ),
                      }
                    : p,
                ),
              ),
            },
          },
        }),
      )
      .then(() => ({ ...portfolio, ...nextPortfolio }));
}

export { updateProjectPortfolio };
